module.exports = __webpack_public_path__ + "img/not-authorized-dark.3d406fda.svg";